<div class="container">
  <app-banner-one class="container__banner"></app-banner-one>
  <div class="container__banner-description">
    <app-banner-description></app-banner-description>
  </div>
  <app-section-books
    class="container__section container__books"
    id="section-books"
    [books]="books"
    [disableCarousel]="true"
  >
  </app-section-books>
  <div
    *ngIf="reviewsData"
    class="container__reviews"
  >
    <lib-section-reviews
      imageTitleSrc="assets/images/title-reviews-2.png"
      imageTitleText="モニターの皆様からのご感想"
      [reviews]="reviewsData"
      [showMonster]="false"
    >
      <div style="text-align: center; margin-top: 20px">
        <a
          class="review-link"
          routerLink="/reviews"
          >すべてのレビューを読む</a
        >
      </div>
    </lib-section-reviews>
  </div>
  <div class="container__section-steps">
    <lib-section-steps [steps]="sectionSteps"></lib-section-steps>
  </div>
  <div
    *ngIf="descriptionData"
    class="container__description"
  >
    <lib-description [description]="descriptionData"></lib-description>
  </div>
  <div
    id="reviews"
    class="container__section-reviews"
  >
    <!-- <lib-section-reviews-yotpo-v3-book
      [alias]="Froebelkan.alias"
      [caption]="Froebelkan.caption"
      [prices]="Froebelkan.prices"
      [photo]="Froebelkan.previewPhoto"
      title="リアルタイムレビュー"
      instanceId="1020425"
      [showMonster]="false"
    ></lib-section-reviews-yotpo-v3-book> -->
    <lib-section-reviews-yotpo-v3-common
      class="wrap__section-reviews"
      instanceId="1162736"
      [showMonster]="false"
    ></lib-section-reviews-yotpo-v3-common>
  </div>
  <div class="container__section-faq">
    <lib-section-faq
      [condensed]="true"
      [faqData]="faqDataCondensed"
      (buttonClick)="onFaqButtonClick()"
    ></lib-section-faq>
  </div>
  <div class="container__section-footer-banner">
    <app-section-footer-banner></app-section-footer-banner>
  </div>
  <div class="container__section-footer-banners">
    <app-section-footer-banners></app-section-footer-banners>
    <br /><br />
    <p>©やなせたかし　©ISHIKAWA Hyuga　©minna</p>
  </div>
</div>

<app-scroll-top></app-scroll-top>

<ng-template
  #reviewsTpl
  let-review
>
  <section class="reviews">
    <div class="reviews__content">
      <p
        *ngFor="let text of review.text"
        class="reviews-text"
      >
        {{ text }}
      </p>
    </div>
    <footer class="reviews__footer">
      <a
        href="#reviews"
        class="reviews-text"
        >レビューを読む</a
      >
      <img
        src="assets/images/reviews-stars.png"
        alt="★★★★★"
        class="reviews-stars"
      />
    </footer>
  </section>
</ng-template>
